var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRequetBoxPageBookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.292 2.082v20.833H3.125V2.082h4.167zm2.083 0h10.422a2.08 2.08 0 012.078 2.073v16.687c0 1.145-.93 2.073-2.078 2.073H9.375V2.082zm13.542 4.167H25v4.166h-2.083V6.25zm0 6.25H25v4.166h-2.083V12.5zm-7.292 0a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167zM12.5 16.665h6.25a3.125 3.125 0 10-6.25 0z",
    fill: "#C9E9E7"
  })));
}

export default SvgIconRequetBoxPageBookIcon;